import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  padding: 18,
  border: '1px solid #707070',
  borderRadius: '8px',
}));

export const BtnStyled = styled(Button)({
  width: 240,
  height: 40,
  fontSize: '14px',
});

export const BtnSecondaryStyled = styled(Button)(({ theme }) => ({
  width: 240,
  height: 40,
  fontSize: '14px',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.global.white,
  border: 'none',
}));
